import React, { useEffect, useState } from 'react';
import axios from 'axios';
// require('dotenv').config();
const AdminUsers = () => {
  const [contacts, setContacts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('Sorting'); // default: newest first

  const contactsPerPage = 10;

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/contact`);
        setContacts(sortData(res.data, sortBy));
      } catch (err) {
        console.error('Error fetching contacts:', err);
      }
    };

    fetchContacts();
  }, [sortBy]);

  const sortData = (data, sortBy) => {
    return [...data].sort((a, b) => {
      if (sortBy === 'date-desc') {
        return new Date(b.createdAt) - new Date(a.createdAt);
      } else if (sortBy === 'date-asc') {
        return new Date(a.createdAt) - new Date(b.createdAt);
      } else if (sortBy === 'name-asc') {
        return a.name.localeCompare(b.name);
      } else if (sortBy === 'name-desc') {
        return b.name.localeCompare(a.name);
      }
      return 0;
    });
  };

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    setCurrentPage(1); // Reset to first page when sort changes
  };

  // Pagination logic
  const indexOfLast = currentPage * contactsPerPage;
  const indexOfFirst = indexOfLast - contactsPerPage;
  const currentContacts = contacts.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(contacts.length / contactsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  return (
    <div className=" font-[Poppins]">
      <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
        {/* <h1 className="text-xl font-[500] font-[Poppins]">User Inquiry</h1> */}
        <h1 className="text-3xl font-bold mb-4">User Inquiry</h1>
      {/* <h2 className="text-xl text-gray-600 mb-6">Submitted Applications</h2> */}
        <select
          value={sortBy}
          onChange={handleSortChange}
          className="border px-3 py-2 rounded font-[Poppins] outline-none"
        >
          <option value="" >Sorting</option>
          <option value="date-desc">Newest First</option>
          <option value="date-asc">Oldest First</option>
          <option value="name-asc">Name A–Z</option>
          <option value="name-desc">Name Z–A</option>
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
  {currentContacts.length === 0 ? (
    <p className="text-center col-span-full text-gray-500">No inquiries found.</p>
  ) : (
    currentContacts.map((contact) => (
      <div
        key={contact.id}
        className="bg-white border border-gray-200 rounded-xl shadow-lg p-6 space-y-2 hover:shadow-xl transition-shadow duration-300"
      >
        <div className="text-lg font-semibold text-pink-700">
          {contact.name}
        </div>

        <div className="text-sm space-y-1">
          <p><span className="font-semibold text-gray-700">Email:</span> {contact.email}</p>
          {contact.phone && (
            <p><span className="font-semibold text-gray-700">Phone:</span> {contact.phone}</p>
          )}
          {contact.subject && (
            <p><span className="font-semibold text-gray-700">Subject:</span> {contact.subject}</p>
          )}
          <div>
            <p className="font-semibold text-gray-700 mb-1">Message:</p>
            <div className="max-h-32 overflow-auto bg-gray-50 p-3 rounded text-gray-800 border border-gray-100 text-sm">
              {contact.message}
            </div>
          </div>
        </div>

        <p className="text-xs text-gray-400 mt-3">
          Submitted on: {new Date(contact.createdAt).toLocaleString()}
        </p>
      </div>
    ))
  )}
</div>



      {/* Pagination controls */}
      {contacts.length > contactsPerPage && (
        <div className="flex justify-between items-center mt-6">
          <button
            onClick={prevPage}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-sm font-medium">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={nextPage}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminUsers;
